import { render } from "./UpdateEvent.vue?vue&type=template&id=ea1c0e32&scoped=true"
import script from "./UpdateEvent.vue?vue&type=script&lang=js"
export * from "./UpdateEvent.vue?vue&type=script&lang=js"

import "./UpdateEvent.vue?vue&type=style&index=0&id=ea1c0e32&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ea1c0e32"

export default script